import Field from "@/components/Field";
import HourAllocationTypeSelect from "@/modules/projects/components/HourAllocationTypeSelect";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface HourAllocationTypeFieldProps {
  required?: boolean;
}

const HourAllocationTypeFieldComponent = ({
  required = false,
}: HourAllocationTypeFieldProps) => {
  const { t } = useTranslation();
  return (
    <Field
      name="hour_allocation_type"
      label={t("hourAllocationType.label")}
      required={required}
      className="space-y-2"
      render={({ field }) => {
        return (
          <HourAllocationTypeSelect
            inDialog
            loading="eager"
            className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            {...field}
            defaultItem={{
              id: field.value,
              name: field.value
                ? t(`hourAllocationType.${field.value}`)
                : undefined,
            }}
          />
        );
      }}
    />
  );
};

export const HourAllocationTypeField = memo(HourAllocationTypeFieldComponent);
